import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * メモ
 */
export class Memo extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): Memo {
    if (value.length > this.validationRule.max.value) {
      throw new Error(this.validationRule.max.message);
    }
    return new Memo(value);
  }

  /** タイプ */
  static get type(): string {
    return 'text';
  }

  /** キー */
  static get key(): string {
    return 'memo';
  }

  /** ラベル */
  static get label(): string {
    return 'メモ：テキスト（500文字以下）';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return 'メモの内容を入力してください';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 最大 */
      max: {
        /** 値 */
        value: 500,
        /** メッセージ */
        message: '500文字以下にしてください',
      },
    };
  }
}
